import {
  ApiDelete,
  ApiGetConsulta,
  ApiPostNew,
  ApiPut
} from '../../../services/apiService';

import Swal from 'sweetalert2';

export async function questionarioAreaPost(data) {
  try {
    const response = await ApiPostNew('/v1/questionarioArea', data);
    if (response.data.mensagem.msg.slice(0, 3) === '100') {
      alert('Registro salvo com sucesso!');
      return true;
    }
    alert(response.data.mensagem.msg);
    return false;
  } catch (err) {
    console.log(err);
  }
}

export async function questionarioAreaUpdate(data) {
  try {
    const response = await ApiPut(
      `/v1/area/${data.areaID}`,
      data,
      localStorage.getItem('sessionToken')
    );
    if (response.data.mensagem.msg.slice(0, 3) === '100') {
      alert('Registro atualizado com sucesso!');
      return true;
    }
    alert(response.data.mensagem.msg);
    return false;
  } catch (err) {
    console.log(err);
  }
}

export async function questionarioAreaDelete(data) {
  await Swal.fire({
    title: 'Deletar registro?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Confirmar'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await ApiDelete(
          `/v1/questionarioArea`,
          data,
          localStorage.getItem('sessionToken')
        );
        if (response.data.mensagem.msg.slice(0, 3) === '100') {
          alert('Registro deletado com sucesso!');
          return true;
        }
        alert(response.data.mensagem.msg);
        return false;
      } catch (err) {
        console.log(err);
      }
    }
  });
}

export async function questionarioAreaSelect() {
  try {
    const response = await ApiGetConsulta(
      '/v1/questionarioArea',
      localStorage.getItem('sessionToken')
    );
    return response?.data?.dados;
  } catch (err) {
    console.log(err);
  }
}
